import { useCallback, useEffect, useState } from 'react'
import type { Paycode } from 'repository/timekeeper/@types/PaycodeModel'
import { gettingPaycodes } from 'utils/PaycodesCombination'

interface UsePaycodesOptionsParams {
    enabled?: boolean
    reloadKey?: unknown
}

interface UsePaycodesOptionsResult {
    paycodes: Paycode[]
    loadingPaycodes: boolean
    loadPaycodes: () => Promise<void>
    setPaycodes: React.Dispatch<React.SetStateAction<Paycode[]>>
    setLoadingPaycodes: React.Dispatch<React.SetStateAction<boolean>>
}

export const usePaycodesOptions = ({ enabled = true, reloadKey }: UsePaycodesOptionsParams = {}): UsePaycodesOptionsResult => {
    const [paycodes, setPaycodes] = useState<Paycode[]>([])
    const [loadingPaycodes, setLoadingPaycodes] = useState(false)

    const loadPaycodes = useCallback(async () => {
        try {
            const response = await gettingPaycodes(setLoadingPaycodes)
            setPaycodes(response as Paycode[])
        } catch (error) {
            console.error(error)
            setPaycodes([])
        } finally {
            setLoadingPaycodes(false)
        }
    }, [])

    useEffect(() => {
        if (!enabled) {
            return
        }

        loadPaycodes()
    }, [enabled, reloadKey, loadPaycodes])

    return {
        paycodes,
        loadingPaycodes,
        loadPaycodes,
        setPaycodes,
        setLoadingPaycodes,
    }
}
